import React, {useState} from 'react';
import {useTranslation, withTranslation} from "react-i18next";
import {connect, DispatchProp} from "react-redux";
import {RootState} from "../../../../../reducers";
import AgeRestrictedContext from "../../../../services/Common/AgeRestrictedContext";
import PopupModal from "../../../../components/Modal/PopupModal";
import IframeWidget from "../../../../utils/IframeWidget";


interface OwnProps {
    onHide: () => void,
    onSave: () => void
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps & DispatchProp;

const AgeRestrictedModalComponent = (props: Props) => {
    const [loading, setLoading] = useState(false);
    const [modal, setModal] = useState(true);
    let {t} = useTranslation();

    const onShow = () => {
    }

    const save = () => {
        AgeRestrictedContext.accept();
        props.onSave();
        IframeWidget.onHide();
    }
    const onHide = () => {
        setModal(false);
    }

    return (
        <React.Fragment>
            <div className={"alert alert-warning"}>
                <p>
                    {t("modules.menu.field.alcohol_advert.title")}
                </p>
                {!modal && (
                    <button type="button" className={"btn btn-primary" + (loading ? ' loading' : '')}
                            onClick={() => setModal(true)}>
                        {t("modules.menu.action.accept.title")}
                    </button>
                )}
            </div>
            <PopupModal
                bodyContent={
                    <div>
                        {t("modules.menu.field.alcohol_advert.title")}
                        {t("modules.menu.field.are_you_an_adult.title")}
                    </div>
                }
                title={t("modules.menu.field.age_confirmation.title")}
                show={modal}
                onHide={onHide}
                onShow={onShow}
                primaryButton={
                    <button type="button" className={"btn btn-primary w-100" + (loading ? ' loading' : '')}
                            onClick={save}>
                        {t("modules.menu.field.yes.title")}
                    </button>
                }
                secondaryButton={
                    <button type="button" className={"btn btn-secondary w-100" + (loading ? ' loading' : '')}
                            data-dismiss="modal" onClick={() => onHide()}>
                        {t("modules.menu.field.no.title")}
                    </button>
                }
            />
        </React.Fragment>
    )
}

const mapStateToProps = (state: RootState) => ({})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(AgeRestrictedModalComponent));